import React from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { LeaseDealsHiddenGemsEntry } from 'site-modules/lease-deals/components/lease-deals-hidden-gems-entry/lease-deals-hidden-gems-entry';
import { withCmsContent } from 'site-modules/lease-deals/components/with-cms-content/with-cms-content';

export function LeaseDealsTypeContentUI({ content = undefined, leaseDealsData = undefined }) {
  if (!content) {
    return null;
  }

  const footerEntry = content.child('footer');
  const children = footerEntry.children();

  return (
    <div className="mb-1_5">
      {children.map(child => (
        <LeaseDealsHiddenGemsEntry key={child.id} entry={child} leaseDealsData={leaseDealsData} />
      ))}
    </div>
  );
}

LeaseDealsTypeContentUI.propTypes = {
  content: CmsEntities.Content,
  leaseDealsData: PropTypes.shape({
    deals: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

export const LeaseDealsTypeContent = withCmsContent(LeaseDealsTypeContentUI);
